/**
 * @prettier
 * @author Alexander Nagelberg
 */
import React from 'react'
import { reduxForm, Field } from 'redux-form'

import LgyFormSubmit from 'app/components/util/lgy-form-submit-v2/LgyFormSubmit'
import LgyInputField from 'app/components/util/lgy-input-field-v2/LgyInputField'
import { formatLin, normalizeLin } from 'app/utils/fieldUtils'
import { lengthExactly, required, numeric } from 'app/utils/validations'

import '../styles/loansearch.scss'

const lengthExactly12 = lengthExactly(12)

/**
 *
 * @param {Object} props
 * @param {Boolean} [props.hardLink] causes app reload necessary to switch between v1/v2
 * @param {*} props.props remaining props passed to LgyFormSubmit
 * @returns
 */
const LoanSearch = ({ handleSubmit, ...props }) => (
  <div className='lgy-lender-workspace-search usa-prose'>
    <h3>Lender Workspace</h3>
    <ul className='lgy-lender-search-info usa-list'>
      <li>
        <span>Remit Funding Fee and Issue Guaranty</span>
      </li>
      <li>
        <span>Request Funding Fee Refund/Rescind loan</span>
      </li>
      <li>
        <span>Retrieve Loan Guaranty Certificate</span>
      </li>
    </ul>
    <form autoComplete='off' onSubmit={handleSubmit}>
      <Field
        component={LgyInputField}
        name='lin'
        label='Search for LIN'
        placeholder='XX-XX-X-XXXXXXX'
        maxLength='15'
        validate={[required, lengthExactly12, numeric]}
        format={formatLin}
        normalize={normalizeLin}
        required
      />
      <LgyFormSubmit {...props} />
    </form>
  </div>
)

export default reduxForm({ form: 'lender-search' })(LoanSearch)
